__turbopack_context__.v({
  "copyright": "BaseFooter-module__wppNGq__copyright",
  "footer": "BaseFooter-module__wppNGq__footer",
  "link-item": "BaseFooter-module__wppNGq__link-item",
  "link-item-highlighted": "BaseFooter-module__wppNGq__link-item-highlighted",
  "links-group": "BaseFooter-module__wppNGq__links-group",
  "links-row": "BaseFooter-module__wppNGq__links-row",
  "logo": "BaseFooter-module__wppNGq__logo",
});
